import React from 'react';

import DownloadInformation from '../../controls/member-grid/DownloadInformation';

const DownloadSheet = ({ companyInfo, entityType }) => {
  return (
    <DownloadInformation companyInfo={companyInfo} entityType={entityType} />
  );
};

export default DownloadSheet;
